// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"88f3f5eb","175":"95a29413","293":"e6670d4d","453":"f733836c","533":"ee99f061","563":"a3e11440","885":"e36631f1","923":"574213dc"}[chunkId] + ".chunk.js";
};